import { createTheme } from "@mui/material";
import { components } from "./components";
import { palette } from "./palette";
import { typography } from "./typography";
import { skSK as coreSkSK } from '@mui/material/locale';
import { skSK } from '@mui/x-date-pickers/locales';

export const pkpTheme = createTheme({
    palette,
    typography,
    components,
    variables: {
        drawerWidth: 268,
        appBarHeight: 64,
        spacing: 8,
        primaryButtonFocusBorderColor: '#003C9B',
    }
}, skSK, coreSkSK);

export const kpasPkpTheme = createTheme(pkpTheme, {
    palette: {
        primary: {
            main: '#005baa',
            light: '#c1e0ff',
            dark: '#00376b',
            contrastText: '#FFFFFF',
        },
    },
});
